<template>
  <div id="player-id">
    <div ref="draggableContainer" class="draggable-container" :class="{'draggable-text-speech': isTextSpeech, 'draggable-audio': hasAudio}" v-if="isDesktop">
      <div id="draggable-header">
        <slot name="header">
          <!-- <feather-icon class="multimedia-drag-icon" icon="MoveIcon" :svgClasses="['h-6 w-6']"></feather-icon> -->
          <vs-button radius class="multimedia-close-icon" type="filled" icon-pack="feather" icon="icon-x"
            @click.stop="close"></vs-button>
          <!-- <feather-icon
            @click.stop="close"
            class="multimedia-close-icon"
            icon="XIcon"
            :svgClasses="['h-6 w-6']"
          ></feather-icon> -->
        </slot>
      </div>
      <slot name="main">
        <div class="draggable-multimedia-content">
          <div class="content-header" @mousedown="dragMouseDown">
            <div class="flex justify-between flex-wrap">
                <p class="item-commodity align-self-center">{{ getSubjectName(reportDetail.subjects) }}</p>
              <span class="item-date">{{ reportDetail.data_object | moment("from") }}</span>
            </div>

            <div class="content-field mt-1 mb-2" v-if="!hasAudio">
              <p class="card-text-title mb-2 card-title">{{ title | truncateclamp(80) }}</p>
            </div>
            <!-- <div class="cursor-pointer display-detaiil" @click.stop="goToDetail">
              <span>
                <p class="text-primary">{{$t('MULTIMEDIA').Details}}</p>
              </span>
            </div> -->
          </div>
          <!-- <div class="text-speech-container" v-if="isTextSpeech"> -->
          <div class="speech mb-5 mt-5 mr-2 ml-2" v-if="isTextSpeech">
            <speech-text-component :detail="reportDetail"></speech-text-component>
            <!-- <div class="img-back">
              <vs-button radius type="flat" icon="play_arrow" size="large" v-if="!isPlaying"
                @click="onSpeech" class="btn-play"></vs-button>
              <vs-button radius type="flat" icon="pause" class="btn-play" size="large" v-if="isPlaying" @click="onPauseSpeech"></vs-button>
              <template v-if="hasImageOrThumbUrl">
                <img class="card-img" :src="imageUrl" />
              </template>
              <template v-else>
                <img class="card-img" :src="imageReportUrl" />
              </template>
            </div> -->
                <!-- <div class="card-img-empty"></div> -->
          </div>
          <div class="youtube-container" v-if="hasYoutube && !isTextSpeech">
            <vue-plyr ref="draggableMultimediaYoutube" :emit="['ended']" @ended="playNextOnPlaylist" :autoplay="true">
              <div class="plyr__video-embed">
                <iframe id="iframe-youtube" :src="youtubeLink" allowfullscreen allowtransparency
                  allow="autoplay" sandbox="allow-same-origin allow-scripts allow-popups allow-presentation allow-forms allow-modals allow-downloads allow-pointer-lock allow-top-navigation allow-popups-to-escape-sandbox"></iframe>
              </div>
            </vue-plyr>
          </div>

          <div class="soundcloud-container" v-if="hasSoundCloud && !isTextSpeech">
            <iframe id="sc-widget2" :src="soundCloudLink" width="100%" height="200" scrolling="no"
              frameborder="no" allow="autoplay"></iframe>
          </div>

          <div class="soundcloud-container" v-if="hasSpotify && !isTextSpeech">
            <iframe :src="spotifyLink" width="100%" height="200" frameborder="0" allowtransparency="true"
              allow="encrypted-media" autoplay></iframe>
          </div>

          <div v-if="hasAudio && !isTextSpeech">
            <podcast-page ref="podcastpage" :detail="reportDetail" :autoplay="true" @playNextOnPlaylist="playNextOnPlaylist"></podcast-page>
            <!-- <vue-plyr ref="draggableMultimediaAudio" :emit="['ended']" @ended="playNextOnPlaylist">
              <audio>
                <source :src="audioLink" :type="audioType" />
              </audio>
            </vue-plyr> -->
          </div>
        </div>
      </slot>
      <!-- <slot name="footer">Footer</slot> -->
    </div>
    <!-- MOBILE -->
    <div class="draggable-container" v-else>
      <div id="draggable-header">
        <slot name="header">
          <!-- <feather-icon class="multimedia-drag-icon" icon="MoveIcon" :svgClasses="['h-6 w-6']"></feather-icon> -->
          <vs-button radius class="multimedia-close-icon" type="filled" icon-pack="feather" icon="icon-x"
            @click.stop="close"></vs-button>
          <!-- <feather-icon
            @click.stop="close"
            class="multimedia-close-icon"
            icon="XIcon"
            :svgClasses="['h-6 w-6']"
          ></feather-icon>-->
        </slot>
      </div>
      <div class="content-header" @click.stop="goToDetail" @mousedown="dragMouseDown">
        <div>
          <span>
            <p class="text-primary card-text-commodity custom-card-text-commodity-mobile">
              {{ getSubjectName(reportDetail.subjects) }}</p>
          </span>
          <span class="mr-1">—</span>
          <div class="content-field custom-content-field-mobile" v-if="!hasAudio">
            <p class="card-text-title card-title custom-card-title-mobile">{{ title | truncateclamp(80) }}</p>
          </div>
          <span class="mr-1" v-if="!hasAudio">—</span>
          <span class="item-date custom-item-date-mobile">{{ reportDetail.data_object | moment("from") }}</span>

          <!-- <div class="icons-controller"> -->
          <!-- <feather-icon
            v-if="playlistActive"
            @click.stop="closeMediaPlaylist"
            class="multimedia-close-icon cursor-pointer mr-2"
            icon="MaximizeIcon"
            :svgClasses="['h-4 w-4']"
          ></feather-icon>
            <feather-icon
            v-if="!playlistActive"
            @click.stop="openMediaPlaylist"
            class="multimedia-close-icon cursor-pointer mr-2"
            icon="MinimizeIcon"
            :svgClasses="['h-4 w-4']"
          ></feather-icon> -->
          <!-- <feather-icon
            @click.stop="close"
            class="multimedia-close-icon cursor-pointer"
            icon="XIcon"
            :svgClasses="['h-6 w-6']"
          ></feather-icon> -->
          <!-- </div> -->
          <!-- <span class="item-date">{{ reportDetail.data_object | moment("from") }}</span> -->
        </div>

        <!-- <div class="content-field" @click.stop="goToDetail">
          <p class="text-primary card-text-commodity">{{commodityName}}</p>
          <h6 class="card-text-title mb-2 card-title">{{title | truncateclamp(80)}}</h6>
        </div> -->
        <!-- <div class="cursor-pointer display-detaiil" >
          <span>
            <p class="text-primary">Ver detalhes</p>
          </span>
        </div> -->
      </div>
      <div class="text-speech-container" v-if="isTextSpeech">
        <div class="img-back">
          <vs-button radius type="flat" icon="play_arrow" size="large" v-if="!isPlaying" @click="onSpeech"></vs-button>
          <vs-button radius type="flat" icon="pause" size="large" v-if="isPlaying" @click="onPauseSpeech"></vs-button>
          <template v-if="hasImageOrThumbUrl">
            <img class="card-img" :src="imageUrl" />
          </template>
          <template v-else>
            <img class="card-img" :src="imageReportUrl" />
            <!-- <div class="card-img-empty"></div> -->
          </template>
        </div>
      </div>
      <div class="youtube-container" v-if="hasYoutube && !isTextSpeech">
        <vue-plyr ref="draggableMultimediaYoutube" :emit="['ended']" @ended="playNextOnPlaylist" :autoplay="true">
          <div class="plyr__video-embed player-youtube">
            <iframe id="iframe-youtube" :src="youtubeLink" allowfullscreen allowtransparency class="player-safras"
              allow="autoplay"></iframe>
          </div>
        </vue-plyr>
      </div>
      <div class="soundcloud-container" v-if="hasSoundCloud && !isTextSpeech">
        <iframe id="sc-widget2" :src="soundCloudLink" width="100%" height="100px" scrolling="no" frameborder="no" allow="autoplay"></iframe>
      </div>

      <div class="soundcloud-container" v-if="hasSpotify && !isTextSpeech">
        <iframe :src="spotifyLink" width="100%" height="80px" frameborder="0" allowtransparency="true"
          allow="encrypted-media autoplay" ></iframe>
      </div>
      <div v-if="hasAudio && !isTextSpeech">
        <podcast-page ref="podcastpage" :detail="reportDetail" :autoplay="true" @playNextOnPlaylist="playNextOnPlaylist"></podcast-page>
        <!-- <vue-plyr ref="draggableMultimediaAudio" :emit="['ended']" @ended="playNextOnPlaylist">
          <audio>
            <source :src="audioLink" :type="audioType" />
          </audio>
        </vue-plyr> -->
      </div>
    </div>
  </div>
</template>

<script>
import { EventBus } from "../../../../event-bus";
import AppConstants from "../../../../appConstants";
import TextToSpeech, { textSpeech } from '../../../../plugins/TextToSpeech';
import translateFieldHelper from "../../../../helpers/translate-field-helper";
import SpeechTextComponent from '../SpeechTextComponent.vue';
import PodcastPage from '../PodcastPage.vue';
import localStorageHelper from "../../../../helpers/local-storage-helper";

export default {
  components: { SpeechTextComponent, PodcastPage },
  props: {
    // reportDetail: {
    //   required: true
    // },w
    currentMediaData: {
      require: false
    },
    isTextSpeech: {
      require: false,
      default: false
    },
    isDesktop: {
      require: true,
      default: true
    },
  },
  name: "DraggableMultimedia",
  data() {
    return {
      positions: {
        clientX: undefined,
        clientY: undefined,
        movementX: 0,
        movementY: 0
      },
      refresh: false
    };
  },
  watch: {
    "$store.state.currentMedia"(value) {
      // console.log("data has changed");

      if (this.hasYoutube || this.hasSoundCloud || this.hasAudio || this.hasSpotify) {
        this.refresh = true;
        setTimeout(() => {
          this.refresh = false;
          this.updateCurrentTime();
        }, 500);
      }

      if (this.isTextSpeech) {
        this.cancelSpeech();
        this.refresh = true;
        setTimeout(() => {
          this.refresh = false;
          this.onSpeech();
        }, 500);
      }
    }
  },
  computed: {
    isS4Login() {
      return localStorageHelper.getS4Login();
    },
    playlistActive() {
      return this.$store.state.playlistOpen;
    },
    reportDetail() {
      return this.$store.state.currentMedia;
    },
    isPlaying() {
      return this.$store.state.textSpeechIsPlaying;
    },
    title() {
      if (this.reportDetail) {
        return this.reportDetail.content.title.data;
      }
      return "";
    },
    // commodityName() {
    //   if (this.reportDetail) {
    //     if (this.reportDetail.subjects.length > 0) {
    //       return this.reportDetail.subjects[0].name;
    //     }
    //   }
    //   return "";
    // },
    youtubePlayer() {
      return this.$refs.draggableMultimediaYoutube.player;
    },
    podcastPage() {
      return this.$refs.podcastpage;
    },
    audioPlayer() {
      return this.$refs.draggableMultimediaAudio.player;
    },
    hasSoundCloud() {
      return !!this.reportDetail.soundcloud && !this.refresh;
    },
    soundCloudLink() {
      return `${AppConstants.URL_SOUNDCLOUD_EMBED}${this.reportDetail.soundcloud}&show_teaser=false&auto_play=true&sharing=false`;
    },
    hasYoutube() {
      if (!this.reportDetail) {
        return false;
      }
      return !!this.reportDetail.youtubeId && !this.refresh;

    },
    youtubeLink() {
      if (!this.reportDetail) {
        return "";
      };
      return `${AppConstants.URL_YOUTUBE_EMBED}${this.reportDetail.youtubeId}?iv_load_policy=3&modestbranding=0&playsinline=1&showinfo=0&rel=0&enablejsapi=1&autoplay=1&controls=0`;
    },
    hasSpotify() {
      return !!this.reportDetail.spotify && !this.refresh;
    },
    spotifyLink() {
      return `${AppConstants.URL_SPOTIFY_EMBED}${this.reportDetail.spotify}?play=1`;
    },
    hasAudio() {
      return !!this.reportDetail.audio && !this.refresh;
    },
    audioLink() {
      return this.reportDetail.audio.image_path;
    },
    audioType() {
      if (this.reportDetail.audio) {
        return `audio/${this.reportDetail.audio.extension}`;
      }
      return "";
    },
    textToSpeech() {
      if (this.reportDetail.content.abstract || this.reportDetail.content.text || this.reportDetail.content.title) {
        return `${this.reportDetail.content.title.data} ${this.reportDetail.content.abstract.data} ${this.reportDetail.content.text.data}`;
      }
      return false;
    },
    hasImageOrThumbUrl() {
      return !!this.reportDetail.image || !!this.reportDetail.thumb;
    },
    imageUrl() {
      if (this.reportDetail.image) {
        return this.reportDetail.image.image_path;
      } else if (this.reportDetail.thumb) {
        return this.reportDetail.thumb.image_path;
      }
      return require("@/assets/images/informative/placeholder115.svg");
    },
    imageReportUrl() {
      if (this.reportDetail.characteristic &&
        this.reportDetail.document &&
        this.reportDetail.document.extension.toLowerCase().indexOf('pdf') > 0) {
        this.reportDetail.document.image_filename.split('.').slice(0, -1).join('.') + '.jpg';
        return '';
      }
    },
    currentCommodity() {
      return this.$store.state.currentCommodity
    }
  },
  methods: {
    openMediaPlaylist() {
      EventBus.$emit(AppConstants.BUS_EVENT_RUN_MEDIA_PLAYLIST, this.reportDetail);
      EventBus.$emit(AppConstants.BUS_EVENT_OPEN_PLAYLIST, true);
      // this.close();
    },
    closeMediaPlaylist() {
      EventBus.$emit(AppConstants.BUS_EVENT_OPEN_PLAYLIST, false);
    },
    goToDetail() {
      if (this.playlistActive) {
        EventBus.$emit(AppConstants.BUS_EVENT_CLOSE_PLAYLIST);
      }
      EventBus.$emit(AppConstants.BUS_EVENT_OPEN_REPORT_DETAIL, this.reportDetail);
    },
    onSpeech() {
      TextToSpeech.onSpeech(this.reportDetail);
    },
    onPauseSpeech() {
      TextToSpeech.onPause(this.textToSpeech);
    },
    cancelSpeech() {
      TextToSpeech.onCancel();
    },
    playNextOnPlaylist() {
      EventBus.$emit(
        AppConstants.BUS_EVENT_PLAY_NEXT_PLAYLIST,
        this.reportDetail
      );
    },
    updateCurrentTime() {
      if (!this.currentMediaData) {
        return;
      }
      // if (this.$store.state.currentMediaData.youtubePlayer.isPlaying) {
      if (this.currentMediaData.youtubePlayed) {
        setTimeout(() => {
          this.youtubePlayer.currentTime = this.currentMediaData.youtubeCurrentTime;
          // this.youtubePlayer.currentTime = this.$store.state.currentMediaData.youtubePlayer.currentTime;
          // this.$store.dispatch('updateYoutubeCurrentTime', this.currentMediaData.youtubeCurrentTime);
          this.youtubePlayer.play();
        }, 2000);
      }

      // if (this.$store.state.currentMediaData.audioPlayer.isPlaying) {
      if (this.currentMediaData.audioPlayed) {
        setTimeout(() => {
          this.podcastPage.audioPlayer.currentTime = this.currentMediaData.audioCurrentTime;
          // this.audioPlayer.currentTime = this.$store.state.currentMediaData.youtubePlayer.currentTime;
          this.podcastPage.audioPlayer.play();
          // this.$store.dispatch('updateAudioCurrentTime', this.currentMediaData.audioCurrentTime);
        }, 2000);
      }
    },
    close() {
      if (this.isTextSpeech) {
        this.cancelSpeech();
      }
      this.$emit("close");
    },
    dragMouseDown(event) {
      event.preventDefault();
      // get the mouse cursor position at startup:
      this.positions.clientX = event.clientX;
      this.positions.clientY = event.clientY;
      document.onmousemove = this.elementDrag;
      document.onmouseup = this.closeDragElement;
    },
    elementDrag(event) {
      event.preventDefault();
      this.positions.movementX = this.positions.clientX - event.clientX;
      this.positions.movementY = this.positions.clientY - event.clientY;
      this.positions.clientX = event.clientX;
      this.positions.clientY = event.clientY;
      // set the element's new position:
      this.$refs.draggableContainer.style.top =
        this.$refs.draggableContainer.offsetTop -
        this.positions.movementY +
        "px";
      this.$refs.draggableContainer.style.left =
        this.$refs.draggableContainer.offsetLeft -
        this.positions.movementX +
        "px";
    },
    closeDragElement() {
      document.onmouseup = null;
      document.onmousemove = null;
    },
    getSubjectName(subjects) {
      return translateFieldHelper.getSubjectName(subjects, this.currentCommodity);
    },
  },
  mounted() {
    // const player = YoutubePlayer('player-id', {
    //   width: 640,
    //   height: 360,
    //   videoId: 'VIDEO_ID',
    //   playerVars: {
    //     autoplay: 1,
    //   },
    // });

    // player.on('ready', () => {
    //   // O player está pronto para ser usado
    // });
    console.log('mounted');
    if (this.currentMediaData) {
      this.updateCurrentTime();
    }

    if (this.isTextSpeech) {
      textSpeech.onend = () => {
        this.playNextOnPlaylist();
      };
      this.onSpeech();
    }
  },
  destroyed() {
    this.cancelSpeech();
  },
};
</script>

<style lang="scss">
.draggable-container {
  // position: absolute;
  position: fixed;
  z-index: 99999;
  background: #ffffff;
  // bottom: 30px;
  right: 30px;
  // height: 240px;
  // height: auto;
  width: 360px;
  border-radius: 6px;
  box-shadow: 0 4px 35px 0 rgba(0, 0, 0, 0.5);


  position: absolute;
  z-index: 999999999;
  background: #ffffff;
  bottom: 180px;
  right: 20px;
  height: 150px;
  width: 360px;
  border-radius: 6px;
  box-shadow: 0 4px 35px 0 rgba(0, 0, 0, 0.5);
}
.draggable-text-speech {
  bottom: 100px;
}

#draggable-header {
  z-index: 9999;
  cursor: move;
  height: 0px;

  .multimedia-drag-icon {
    z-index: 9999;
    margin-top: -12px;
    margin-left: -13px;
  }

  .multimedia-close-icon {
    z-index: 9999;
    margin-top: -9px;
    margin-left: -25px;
    margin-right: -7px;
    float: right;
    cursor: pointer;
  }
}

.draggable-multimedia-content {
  .content-header {
    padding: 7px 10px 0px 10px;
    cursor: move;

    .item-date {
      margin-right: 22px;
    }
  }
}

.content-field img {
  // width: 100% !important;
}

.text-speech-container {
  .img-back {
    position: relative;
    // height: 200px;
  }

  button {
    position: absolute;
    right: 45%;
    top: 35%;
  }

  img.card-img {
    width: 100%;
  }
}

.display-detaiil {
  .text-primary {
    text-align-last: right;
    padding-bottom: 5px;
    margin-top: -7px;
  }
}
</style>
